import Image from '@tiptap/extension-image';
import {VueNodeViewRenderer} from '@tiptap/vue-2';
import EmbedMediaTemplate from './EmbedMediaTemplate.vue';
import { mergeAttributes } from '@tiptap/core'

export default Image.extend({
    name: 'EmbedMedia',

    addAttributes() {
        return {
            ...this.parent?.(),

            width: {
                default: '100%',
                renderHTML: (attributes) => {
                    return {
                        width: attributes.width
                    };
                }
            },

            height: {
                default: '100%',
                renderHTML: (attributes) => {
                    return {
                        height: attributes.height
                    };
                }
            },

            isDraggable: {
                default: true,
                renderHTML: (attributes) => {
                    return {};
                }
            }
        };
    },

    addCommands() {
        return {
      setEmbedVideo: options => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
        // return {
        //
        //     ...this.parent?.(),
        //
        //     toggleEmbedMedia:
        //         () =>
        //             ({tr}) => {
        //                 const {node} = tr?.selection;
        //
        //                 if (node?.type?.name === 'EmbedMedia') {
        //                     node.attrs.isDraggable = !node.attrs.isDraggable;
        //                 }
        //             }
        };
    },

    addNodeView() {
        return VueNodeViewRenderer(EmbedMediaTemplate);
    },

    parseHTML() {
        return [
            {
                tag: 'video',
            },
        ]
    },
    renderHTML({HTMLAttributes}) {
        return ['video', mergeAttributes(HTMLAttributes)];
    },
});